import React from "react";
import { AppPage } from "ui/AppPage";

export const PrivacyPolicyPage = () => (
  <AppPage>
    <h2>Privacy policy</h2>
    <p>
      Posted：29.06.2020
      <br />
      Effective：29.06.2020
    </p>
    <h3>Information collection and usage</h3>
    <p>
      We would record your personal information when you sign up, modify account
      information and using Yapa. These information would be used to provide,
      maintain, protect and improve Yapa, or to develop new services.
    </p>

    <h3>Information publication and sharing </h3>
    <p>
      We would not release or sell your personal information to anyone. Except:
    </p>
    <ul>
      <li>You permit a third party to share the information;</li>
      <li>
        We cannot provide your required services without releasing your personal
        information.
      </li>
      <li>
        We need to provide information to those companies who serve you on
        behalf of Yapa. (These companies do not have right to use your personal
        identify information, unless you are notified);
      </li>
      <li>We are forced by legal processes;</li>
      <li>We find that you have violated any of our service terms.</li>
    </ul>

    <h3>Cookies</h3>
    <p>
      Yapa uses Cookies to store user data and customize web page contents.
      Please enable Cookies in your web browser. Yapa uses Google Analytics
      which uses cookies to operate.
    </p>

    <h3>Advertising</h3>
    <p>We do not cooperate with any advertising service.</p>

    <h3>Revision of privacy policy</h3>
    <p>
      We may revise the privacy policy. Whenever there is a big revision of
      privacy policy about personal information, we would make conspicuous
      notification at our website.
    </p>
  </AppPage>
);
